// Libs
import { HTTPVerb } from '@sift/resift/redux/DataService';
import dataServiceActionHandlers from '@sift/resift/redux/reducers/dataServiceActionHandlers';

// Actions
import {
  DOMAIN_OPTIONS_FETCH,
  PASSWORD_LOGIN_FETCH,
  FORGOT_PASSWORD_FETCH,
  VALIDATE_RESET_TOKEN_FETCH,
  RESET_PASSWORD_FETCH,
  VALIDATE_INVITE_TOKEN_FETCH,
  COMPLETE_PASSWORD_INVITE_FETCH,
  CONFIRM_SUBSCRIPTION_FETCH,
  RESOLVE_SUBSCRIPTION_FETCH,
} from './login';
// Routes
// TODO: add routes here

export const unauthorizedHandler = (next, action) => {
  // do nothing because we expect unauthorized on the login site
};

export const DataServiceActionHandlers = {
  ...dataServiceActionHandlers,

  [DOMAIN_OPTIONS_FETCH]: {
    httpMethod: HTTPVerb.POST,
    route: 'loginoptions',
  },

  [PASSWORD_LOGIN_FETCH]: {
    httpMethod: HTTPVerb.POST,
    route: (state, action) => {
      const { clientId, directoryId } = action.payload.data;
      const urlSegments = ['login', clientId];

      if (directoryId) {
        urlSegments.push(directoryId);
      }

      urlSegments.push('password');

      // login/:clientId/:directoryId?/password
      return urlSegments.join('/');
    },
  },

  [FORGOT_PASSWORD_FETCH]: {
    httpMethod: HTTPVerb.POST,
    route: (state, action) => {
      const { clientId, directoryId } = action.payload.data;
      const urlSegments = ['login', clientId];

      if (directoryId) {
        urlSegments.push(directoryId);
      }

      urlSegments.push('password', 'forgot');

      // login/:clientId/:directoryId?/password/forgot
      return urlSegments.join('/');
    },
  },

  [VALIDATE_RESET_TOKEN_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (state, action) => {
      return `login/${action.payload.query.subdomain}/password/reset`;
    },
  },

  [RESET_PASSWORD_FETCH]: {
    httpMethod: HTTPVerb.POST,
    route: (state, action) => {
      return `login/${action.payload.data.subdomain}/password/reset`;
    },
  },

  [VALIDATE_INVITE_TOKEN_FETCH]: {
    httpMethod: HTTPVerb.GET,
    route: (state, action) => {
      return `invite/${action.payload.query.subdomain}/complete`;
    },
  },

  [COMPLETE_PASSWORD_INVITE_FETCH]: {
    httpMethod: HTTPVerb.POST,
    route: (state, action) => {
      return `invite/${action.payload.data.subdomain}/complete`;
    },
  },
  [CONFIRM_SUBSCRIPTION_FETCH]: {
    httpMethod: HTTPVerb.POST,
    route: () => {
      return 'vendor/microsoft/sift-subscriptions';
    },
  },
  [RESOLVE_SUBSCRIPTION_FETCH]: {
    httpMethod: HTTPVerb.POST,
    route: () => {
      return 'vendor/microsoft/subscription-registrations';
    },
  },
};

export default DataServiceActionHandlers;
